import { render } from "./NbusInquiryList_admin.vue?vue&type=template&id=a7372d76"
import script from "./NbusInquiryList_admin.vue?vue&type=script&lang=js"
export * from "./NbusInquiryList_admin.vue?vue&type=script&lang=js"

import "./NbusInquiryList_admin.vue?vue&type=style&index=0&id=a7372d76&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__